/**
* @Author: zachalam
* @Date:   2017-01-19T15:49:41-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-19T16:52:13-08:00
*/

import React, { Component } from 'react';
import App from '../components/App';
import isObject from 'lodash/isObject';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { resendEmail } from '../actions/authActions';
import { requestGdprDeletion } from '../actions/gdprActions';
import { getTos, acceptTos } from '../actions/tosActions';
import { getPrivacyPolicy } from '../actions/privacyPolicyActions';

class AppContainer extends Component {

  constructor(props) {
    super(props);
    let isIndex = Boolean(props.location.pathname === "/");
    if(isIndex && props.username) {
      browserHistory.push("/search");
    }
  }

  render() {
    return (
      <App {...this.props} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    profile: state.profile,
    username: state.profile.username,
    isFetching: state.common.isFetching,
    show_tos: state.profile.showTOS,
    gdprDeletionError: Boolean(isObject(state.common.errors) && state.common.errors['error_gdpr_deletion']),
    tos: state.tos,
    privacyPolicy: state.privacy_policy
  }
}


// actions to refresh internal/external profile.
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    resendEmail() {
      dispatch(resendEmail());
    },

    requestGdprDeletion(formData) {
      dispatch(requestGdprDeletion(formData));
    },

    getTosText() {
      dispatch(getTos());
    },

    acceptTos(tos_version) {
      dispatch(acceptTos(tos_version))
    },

    getPrivacyPolicy() {
      dispatch(getPrivacyPolicy());
    }

  }
}


export default connect(mapStateToProps,mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/containers/AppContainer.jsx